<template>
  <b-form-group>
    <div slot="label" class="d-flex align-items-baseline">
      <span>{{ label }}</span>
      <b-form-radio-group
        buttons
        size="sm"
        button-variant="outline-secondary"
        :checked="operation"
        :options="operations"
        @input="$emit('update:operation', $event)"
        class="ml-auto mb-0 mr-2"
      />
      <b-button size="sm" variant="outline-secondary" @click="$emit('remove')">
        &times;
      </b-button>
    </div>
    <slot />
  </b-form-group>
</template>

<script>
const OPERATION_INCLUDES = 'includes';
const OPERATION_EXCLUDES = 'excludes';
const OPERATION_ISNULL = 'isnull';
const OPERATION_ISNOTNULL = 'isnotnull';

export default {
  props: {
    label: String,
    operation: String,
    type: String,
  },
  computed: {
    operations() {
      const defaultOperations = [
        OPERATION_INCLUDES,
        OPERATION_EXCLUDES,
        OPERATION_ISNULL,
        OPERATION_ISNOTNULL,
      ];
      let filteredOperations = defaultOperations;

      const allowedFieldOperations = {
        job_type: [OPERATION_INCLUDES, OPERATION_EXCLUDES],
      };

      if (Object.keys(allowedFieldOperations).includes(this.type)) {
        filteredOperations = allowedFieldOperations[this.type];
      }

      return filteredOperations.map((operation) => ({
        value: operation,
        text: this.$t(`filters.advanced.${operation}`),
      }));
    },
  },
};
</script>
